import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";

// PSAK 1 / IAS 1 Statement of Changes in Equity matrix (face of the report).
// Columns = equity components (Modal Saham | Saldo Laba | OCI), rows = opening
// balance -> period movements -> ending balance, plus a Total Ekuitas column.
// `matrix` comes straight from the capital-statement API (res.data.matrix).
const Amount = ({ value }) => (
  <NumericFormat
    displayType="text"
    value={value ?? 0}
    thousandSeparator="."
    decimalSeparator=","
    decimalScale={2}
    prefix="Rp"
  />
);

const CapitalMatrixTable = ({ matrix }) => {
  const { t } = useTranslation();
  const columns = matrix?.columns ?? [];
  const rows = matrix?.rows ?? [];

  if (rows.length === 0) return null;

  return (
    <div className="overflow-x-auto">
      <div className="inline-block min-w-full align-middle">
        <div className="overflow-hidden border border-gray-200 rounded-lg shadow-sm">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 font-medium text-sm text-left text-gray-900 whitespace-nowrap">
                  {t("capitalStatement.description", "Keterangan")}
                </th>
                {columns.map((col) => (
                  <th
                    key={col.key}
                    className="px-4 py-2 font-medium text-sm text-right text-gray-900 whitespace-nowrap"
                  >
                    {col.label}
                  </th>
                ))}
                <th className="px-4 py-2 font-medium text-sm text-right text-gray-900 whitespace-nowrap">
                  {matrix.totalLabel || "Total Ekuitas"}
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {rows.map((row) => {
                const amountClass = row.bold
                  ? "font-semibold text-gray-900"
                  : "font-normal text-gray-700";
                return (
                  <tr key={row.key} className={row.bold ? "bg-gray-50" : undefined}>
                    <td
                      className={`px-4 py-2 text-sm text-left text-gray-900 whitespace-nowrap ${
                        row.bold ? "font-semibold" : "font-normal"
                      }`}
                    >
                      {row.label}
                    </td>
                    {columns.map((col) => (
                      <td
                        key={col.key}
                        className={`px-4 py-2 text-sm text-right whitespace-nowrap ${amountClass}`}
                      >
                        <Amount value={row.values?.[col.key] ?? 0} />
                      </td>
                    ))}
                    <td
                      className={`px-4 py-2 text-sm text-right whitespace-nowrap ${amountClass}`}
                    >
                      <Amount value={row.total} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CapitalMatrixTable;
